module.exports = __webpack_public_path__ + "media/images/icons/country_flags/vn-e80173a9c3cbaa60c5937fb87b9dcb3f.svg";